const bookingStatusBadge = (value) => {

    if (value == null || value === "") {
        return <span className="text-muted">—</span>
    }

    const display = String(value).trim()
    let wrapClass = "table-sb-inactive"
    let dotClass = "dot-icon-inactive"

    switch (display.toLowerCase()) {
        case "pending":
            wrapClass = "table-sb-not-marked"
            dotClass = "dot-icon-not-marked"
            break
        case "approved":
            wrapClass = "table-sb-active"
            dotClass = "dot-icon-active"
            break
        case "rejected":
            wrapClass = "table-sb-unpaid"
            dotClass = "dot-icon-unpaid"
            break
        case "cancelled":
            wrapClass = "table-sb-inactive"
            dotClass = "dot-icon-inactive"
            break
        default:
            break
    }

    return (
        <span className={`badge rounded-pill px-2 py-1 d-inline-flex align-items-center gap-2 ${wrapClass}`}>
            <span className={`dot-icon rounded-circle ${dotClass}`} />
            {display}
        </span>
    )
}

export default bookingStatusBadge;